// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"dbe79b6c","264":"8b7dab4a","322":"842b8e26","472":"fa6bc12f","479":"095236c0","655":"e93b0448"}[chunkId] + ".chunk.js";
};